<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <VoHoiatus class="ma-2"></VoHoiatus>
                    <h1 class="px-2">Hoolduskava</h1>
                    <p class="px-2 text-textDark text-justify mt-3">Pärast kohtuotsuse jõustumist selgitab ametnik välja
                        Teie seaduserikkumise põhipõhjused, samuti muud probleemid, mis on takistanud seaduskuulekalt
                        elamist.
                        Arvestades ka kohtuotsusega pandud kontrollnõudeid ja kohustusi ning koostöös Teiega koostab ta
                        kriminaalhoolduse läbiviimise kava – hoolduskava.
                        Hoolduskavas on kirjeldatud erinevad tegevused kogu kriminaalhoolduse perioodiks.
                        Lisaks hoolduskavas plaanitud tegevuste läbiviimisele saame registreerimise ajal vestelda ja
                        arutleda muudel Teie jaoks olulistel ning vajalikel teemadel.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="px-5">
                    <v-data-table class="mt-4 rounded elevation-3" v-model:expanded="tabel.laiendatud" :headers="tabel.paised"
                        :items="tabel.elemendid" :items-per-page="tabel.lehePikkus" :loading="tabel.laeb" show-expand
                        fixed-header single-expand item-key="id">
                        <template #expanded-row="{ item }">
                            <tr class="sisu">
                                <td>
                                </td>
                                <td>
                                    <b>Tähtaeg:</b>
                                </td>
                                <td>
                                    {{ formateeriKuupaev(item.aeg) }}
                                </td>
                            </tr>
                            <tr class="sisu">
                                <td></td>
                                <td>
                                    <b>Tegevuse eesmärk:</b>
                                </td>
                                <td>
                                    {{ item.tulemus }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>

<style scoped>
.sisu {
    background-color: var(--varv-lisa-3);
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import moment from 'moment';
import { HoolduskavaTeenus } from '@/core/hoolduskava-teenus';
import { Hoolduskava } from '@/models/Hoolduskava';
import mixin from '@/core/mixins';

const _hoolduskavaTeenus = new HoolduskavaTeenus();

export default defineComponent({
    name: 'HooldusKava',
    components: { KRHPPaigutus },
    data() {
        return {

            hoolduskavaInfo: new Array<Hoolduskava>(),
            moment: moment,
            tabel: {
                laiendatud: [],
                paised: [
                    {
                        title: '',
                        key: 'data-table-expand',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        }
                    },
                    {
                        title: 'Staatus',
                        key: 'taitmine',
                        width: 100,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Tegevus',
                        key: 'tegevus',
                        width: 300,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                ],
                elemendid: new Array<Hoolduskava>(),
                laeb: false,
                lehePikkus: 25
            },
        }
    },
    mixins: [mixin],
    methods: {
        minuHoolduskavaInfo() {
            this.tabel.laeb = true;
            _hoolduskavaTeenus.minuHoolduskavaInfo().then((hoolduskava) => {
                this.tabel.elemendid = hoolduskava;
            }).finally(() => {
                this.tabel.laeb = false;
            });
        }
    },
    created() {
        this.moment = moment
    },
    mounted() {
        this.minuHoolduskavaInfo();
    }
});
</script>
